import "@/App.css";
import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  const { user, loading } = useAuth();

  // Handle OAuth return: session_id lives in the URL fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-800 border-t-[#D4FF00]" />
      </div>
    );
  }

  return user ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#121212",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#F5F5F5",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
